import { Empty, Modal, Tabs } from "antd";
import moment from "moment";
import { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import apiFactory from "../../api";
import { CHATTING, REACTION_TYPE_LABEL } from "../../config/Constant";
import { useInfoUser } from "../../store/UserStore";
import { BasicMemberInfo } from "../select/directory/BasicMemberInfo";
import { openNotificationError } from "../../utils/Utils";
import { renderMessage } from "../chat/renderMessage";

const ReactionModal = ({
  conversationId,
  requestUuid,
  reactionTypes,
  openModalReaction,
  setOpenModalReaction,
  activeKey,
  setActiveKey,
}) => {
  const { user, languageMap } = useInfoUser();
  const [memberGroupList, setMemberGroupList] = useState([]);
  const [memberPage, setMemberPage] = useState(1);
  const [isMoreMember, setIsMoreMember] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [listSeenTs, setListSeenTs] = useState([]);
  const [memberNameSearch, setMemberNameSearch] = useState("");
  const lastObserver = useRef();

  const changeTab = (key) => {
    setActiveKey(key);
    setMemberGroupList([]);
    setSelectedUserIds([]);
    setIsMoreMember(true);
    setMemberNameSearch("");
    setMemberPage(1);
  };

  const fetchReaction = async () => {
    setIsLoading(true);
    const result = await apiFactory.reactionApi.getReaction({
      requestUuid: requestUuid,
      limit: CHATTING.MESSAGE_LIMIT,
      page: memberPage,
      search: {
        conversationId: conversationId,
        memberName: memberNameSearch,
        viewType: activeKey,
      },
      ts: moment(),
    });

    if (result?.status !== 200) {
      setIsLoading(false);
      return;
    }

    if (result?.data) {
      const memberList = result?.data?.items;
      const memberIds = memberList?.map((member) => member?.userId);
      const orgResponse =
        await apiFactory?.organizationUserApi?.getListOrganization(memberIds);
      const organizationList = orgResponse?.data;

      const memberGroups = memberList?.flatMap((member) => {
        const matchingOrgs = organizationList?.filter(
          (org) => org?.objectId === member?.userId,
        );

        if (!matchingOrgs || matchingOrgs?.length === 0) {
          return { ...member, paths: [] };
        }

        return matchingOrgs?.map((org) => ({
          ...member,
          paths: org?.paths,
        }));
      });

      if (result?.data?.totalItems < memberPage * CHATTING?.MESSAGE_LIMIT)
        setIsMoreMember(false);

      if (memberPage === 1) {
        setMemberGroupList([...memberGroups]);
      } else {
        setMemberGroupList([...memberGroupList, ...memberGroups]);
      }
    } else {
      openNotificationError("Something wrong!");
    }

    setIsLoading(false);
  };

  const lastMemberRef = (node) => {
    if (isLoading || !isMoreMember) return;
    if (lastObserver.current) lastObserver.current.disconnect();

    lastObserver.current = new IntersectionObserver(async (entries) => {
      if (entries[0].isIntersecting) {
        setIsLoading(true);
        setMemberPage(memberPage + 1);
      }
    });

    if (node) lastObserver.current.observe(node);
  };

  const getLastSeenTs = (userId) => {
    let result = listSeenTs.find((s) => s.userId === userId)?.lastSeenTs;
    return result;
  };
  const onChangeMembersCheckBox = (member) => {
    setSelectedUserIds((prevSelectedUserIds) => {
      const updatedUserIds = [...prevSelectedUserIds];
      const index = updatedUserIds.indexOf(member?.userId);

      if (index !== -1) {
        updatedUserIds.splice(index, 1);
      } else {
        updatedUserIds.push(member?.userId);
      }
      return updatedUserIds;
    });
  };
  const generateTabs = () => {
    if (isLoading && memberGroupList?.length === 0) {
      return <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />;
    }

    return (
      <div className="mt-5 modal-show-member-container overflow-y-scroll h-[40vh]">
        {Array.from(
          new Map(
            memberGroupList?.map((item) => [item?.userId, item]),
          )?.values(),
        )?.map((memberGroup, index) => {
          return (
            <div
              key={`${memberGroup?.userId}-${index}`}
              ref={index === memberGroupList?.length - 1 ? lastMemberRef : null}
            >
              <BasicMemberInfo
                languageMap={languageMap}
                memberGroup={memberGroup}
                screenInfo="VIEW_MEMBER_IN_GROUP"
                isHost={memberGroup?.role === "HOST"}
                isAdmin={memberGroup?.role === "ADMIN"}
                isMe={memberGroup?.userId === user?.userId}
                key={memberGroup?.userId}
                isSelectedCombobox={selectedUserIds?.includes(
                  memberGroup?.userId,
                )}
                seenTsInMessage={getLastSeenTs(memberGroup?.userId)}
                onChangeMembersCheckBox={onChangeMembersCheckBox}
                isModaReaction={true}
                reactionOfUser={memberGroup?.reactionType}
              />
            </div>
          );
        })}
      </div>
    );
  };

  useEffect(() => {
    if (!reactionTypes?.includes(activeKey)) {
      setActiveKey("ALL");
    }
    if (requestUuid != null && reactionTypes?.length && openModalReaction)
      fetchReaction();
  }, [memberPage, activeKey, reactionTypes]);

  useEffect(() => {
    if (openModalReaction) setActiveKey("ALL");
  }, [openModalReaction]);

  useEffect(() => {
    if (reactionTypes?.length) {
      const tabsContent = generateTabs();
      const getReactionTypes = reactionTypes?.map((item) => {
        const filterReaction = REACTION_TYPE_LABEL?.find((reaction) =>
          item?.includes(reaction?.type),
        );
        return {
          key: item,
          label: renderMessage(filterReaction?.label, 18),

          children: tabsContent,
        };
      });

      const itemsAll = {
        key: "ALL",
        label: languageMap?.["menu.tab.all"] ?? "All",

        children: tabsContent,
      };

      getReactionTypes?.unshift(itemsAll);
      setTabs(getReactionTypes);
    }
  }, [memberGroupList, selectedUserIds, reactionTypes, requestUuid]);

  return (
    <Modal
      title={languageMap?.["modal.reactions.title"] ?? "Reactions"}
      open={openModalReaction}
      onCancel={() => {
        setOpenModalReaction(false);
      }}
      width="450px"
      footer={false}
    >
      <div className="mt-4 flex flex-col justify-between">
        {reactionTypes?.length > 0 ? (
          <div
          // className="h-[450px]"
          >
            <Tabs
              defaultActiveKey="ALL"
              activeKey={activeKey}
              items={tabs}
              onChange={changeTab}
            />
          </div>
        ) : (
          <h3 style={{ margin: "auto" }}>No one reacted!</h3>
        )}
      </div>
    </Modal>
  );
};
export { ReactionModal };
